"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
exports.view = view;
var mithril_1 = require("../../mithril");
var CONST_CLASS_OBJ = { className: 'material-icons' };
function view(icon, opts) {
    if (opts == null) {
        return (0, mithril_1.m)('i', CONST_CLASS_OBJ, icon);
    }
    if (opts.className) {
        opts.className = opts.className + ' material-icons';
    }
    else {
        opts.className = 'material-icons';
    }
    return (0, mithril_1.m)('i', opts, icon);
}
exports.Icon = { view: view };
//# sourceMappingURL=index.js.map